import StatutMontantSimulation from '../constants/simulation/statutMontantSimulation';
import TypeBudget from '../constants/simulation/typeBudget';
import TypeLigneMontant from '../constants/simulation/typeLigneMontant';
import TypePeriode from '../constants/simulation/typePeriode';
import type LigneMontantReference from '../interfaces/simulation/ligneMontantReference';
import type MontantSimulation from '../interfaces/simulation/montantSimulation';
import type Simulation from '../interfaces/simulation/simulation';
import { getMontantColumnFromPeriode } from './feuilleSaisie/imputation';

const DEFAULT_MONTANT_REFERENCE_BP = [
	{ typeMontant: 'budget_n1', ordre: 0 },
	{ typeMontant: 'realise_n1', ordre: 1 },
] as LigneMontantReference[];

const DEFAULT_MONTANT_REFERENCE_CA = [
	{ typeMontant: 'budget', ordre: 1 },
	{ typeMontant: 'liquide_n', ordre: 2 },
	{ typeMontant: 'engage_n', ordre: 3 },
] as LigneMontantReference[];

const DEFAULT_MONTANT_REFERENCE = [
	{ typeMontant: 'budget', ordre: 1 },
	{ typeMontant: 'realise', ordre: 2 },
] as LigneMontantReference[];

export const getDefaultMontantReference = (etapeBudgetaire: TypeBudget) => {
	if (etapeBudgetaire === TypeBudget.COMPTE_ADMINISTRATIF) {
		return DEFAULT_MONTANT_REFERENCE_CA;
	} else if (etapeBudgetaire === TypeBudget.BUDGET_PRIMITIF) {
		return DEFAULT_MONTANT_REFERENCE_BP;
	}

	return DEFAULT_MONTANT_REFERENCE;
};

export const getMontantSoldeRAR = (item, simulation: Simulation) => {
	let montant = Number(item.report ?? 0);

	if (simulation?.typePeriode === TypePeriode.PROPOSE) {
		montant += Number(item.montant_propose ?? 0);
	} else if (simulation?.typePeriode === TypePeriode.VOTE) {
		montant += Number(item.montant_vote ?? 0);
	}

	return montant;
};

// Types poses par une saisie manuelle (cf la saisie depuis le TreeView)
const TYPES_SAISIE_MANUELLE: string[] = [
	TypeLigneMontant.PROP_DIR,
	TypeLigneMontant.SAI_LIB,
];

// Un montant est considere sans origine quand il n'a pas de type, ou qu'il
// provient d'une saisie manuelle
export const isMontantSansOrigine = (montantSimulation: MontantSimulation) =>
	!montantSimulation.type ||
	TYPES_SAISIE_MANUELLE.includes(montantSimulation.type);

export interface TotauxLigneMontantsSimulation {
	// Total de la colonne de la periode (montant_demande, montant_propose...)
	montant: number;
	// Total de la colonne report
	report: number;
}

// Totaux d'une ligne du TreeView recalcules a partir de ses montants de
// simulation, avec les memes regles que la mise a jour par difference faite
// depuis MontantsSimulationModal :
// - seule la colonne de la periode compte (demande, prop, vote ou rar),
// - un montant refuse n'y est pas compte, sauf au CA ou le statut (herite
// d'une periode precedente) n'a plus cours,
// - le report (rep) est toujours compte, quel que soit le statut
export const getTotauxLigneMontantsSimulation = (
	montantsSimulation: MontantSimulation[],
	typePeriode: TypePeriode,
): TotauxLigneMontantsSimulation => {
	const nameColumn = getMontantColumnFromPeriode(typePeriode);
	const isCA = typePeriode === TypePeriode.CA_CFU;

	let montant = 0;
	let report = 0;
	for (const montantSimulation of montantsSimulation) {
		report += montantSimulation.rep ?? 0;
		if (
			nameColumn &&
			(isCA || montantSimulation.statut !== StatutMontantSimulation.REFUSE)
		) {
			montant += montantSimulation[nameColumn] ?? 0;
		}
	}

	return { montant, report };
};
